import { render, staticRenderFns } from "./Shipment.vue?vue&type=template&id=d6f26790&scoped=true&"
import script from "./Shipment.vue?vue&type=script&lang=js&"
export * from "./Shipment.vue?vue&type=script&lang=js&"
import style0 from "./Shipment.vue?vue&type=style&index=0&id=d6f26790&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f26790",
  null
  
)

export default component.exports